import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b0bmnnd12t: FaireBrandEntity = {
  token: "b_b0bmnnd12t",
  type: "brand",
  name: "Morrow Soft Goods",
  avatarUrl:
    "https://cdn.faire.com/fastly/6efdcd22c4f1092831e23a1c183f2e137205878bc42d23262803a168ef002de1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6704ba4d337765fcc130386b1b338ec8131876abc8ea5bf53e232a9f63f2944a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6efdcd22c4f1092831e23a1c183f2e137205878bc42d23262803a168ef002de1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6704ba4d337765fcc130386b1b338ec8131876abc8ea5bf53e232a9f63f2944a.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 300,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Morrow Soft Goods was founded in 2016 by friends\nStephanie Cleary and Michelle Toney. Both with backgrounds in design, Stephanie in fashion and Michelle in architecture, they were passionate about building a brand that creates beautiful products while simultaneously focusing on sustainability.\n\nWe design everything in our studio in Los Angeles and work with factories across the globe that meet our standards not only for product quality but for ethical production. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:36.312Z",
    importedBy: "entity-db-cli",
  },
};
